import { IdentityDto, HistoryDto } from './../../shared';

export class ClusterConfigDto {
  history: HistoryDto;
  identity: IdentityDto;
  method: string;
  regex: string;
  settings: Map<string, string | number>;
  status: string;

  constructor(d?: ClusterConfigDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);

    if (d.history) {
      this.history = new HistoryDto(d.history);
    }

    if (d.identity) {
      this.identity = new IdentityDto(d.identity);
    }
  }
}
